(function() {
  function q28init() {
    var root = document.getElementById('quiz28-root');
    if (!root) return;

    document.body.appendChild(root);
    document.body.style.setProperty('margin','0','important');
    document.body.style.setProperty('padding','0','important');
    document.body.style.setProperty('background','#fff','important');
    root.style.setProperty('position','fixed','important');
    root.style.setProperty('top','0','important');
    root.style.setProperty('left','0','important');
    root.style.setProperty('width','100%','important');
    root.style.setProperty('height','100%','important');
    root.style.setProperty('overflow-y','auto','important');
    root.style.setProperty('z-index','99999','important');
    root.style.setProperty('background','#fff','important');

    if (!document.getElementById('q28font')) {
      var fl = document.createElement('link');
      fl.id = 'q28font'; fl.rel = 'stylesheet';
      fl.href = 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,600&display=swap';
      document.head.appendChild(fl);
    }

    if (!document.getElementById('q28style')) {
      var st = document.createElement('style');
      st.id = 'q28style';
      st.textContent = [
        "*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }",
        "#quiz28-root { font-family: 'Poppins', sans-serif; }",
        ".q28 { font-family: 'Poppins', sans-serif; -webkit-font-smoothing: antialiased; background: #fff; width: 100%; min-height: 100%; display: flex; flex-direction: column; align-items: center; padding-bottom: 60px; }",
        ".q28-header { width: 100%; background: #fff; border-bottom: 1px solid #DDD6EE; padding: 14px 24px; text-align: center; }",
        ".q28-progress { width: 100% !important; height: 6px !important; background: #DDD6EE !important; position: sticky !important; top: 0 !important; z-index: 99999 !important; display: block !important; }",
        ".q28-progress-fill { height: 6px !important; background: #7C5CBF !important; transition: width 0.5s ease; width: 0%; display: block !important; }",
        ".q28-wrap { width: 100%; max-width: 520px; padding: 28px 20px 0; }",
        ".q28-screen { display: none; }",
        ".q28-screen.active { display: block; animation: q28fadeUp 0.3s ease; }",
        "@keyframes q28fadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }",
        ".q28-badge { display: block; text-align: center; border: 1.5px solid #DDD6EE; color: #7C5CBF; font-size: 11px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; padding: 6px 14px; border-radius: 100px; margin-bottom: 18px; }",
        ".q28-h1 { font-size: 26px; font-weight: 700; color: #2D1F4E; line-height: 1.3; margin-bottom: 10px; text-align: center; }",
        ".q28-h1 em { font-style: italic; color: #7C5CBF; }",
        ".q28-sub { font-size: 14px; color: #8B7EA8; line-height: 1.65; margin-bottom: 22px; text-align: center; }",
        ".q28-sub strong { color: #2D1F4E; font-weight: 600; }",
        ".q28-hero { border-radius: 16px; overflow: hidden; margin-bottom: 22px; background: #E8E0F5; }",
        ".q28-hero img { width: 100%; height: auto; display: block; }",
        ".q28-start-btn { width: 100%; padding: 18px; background: #7C5CBF; color: #fff; border: none; border-radius: 14px; font-family: 'Poppins', sans-serif; font-size: 15px; font-weight: 600; cursor: pointer; margin-bottom: 10px; transition: all 0.2s; }",
        ".q28-start-btn:hover { background: #2D1F4E; transform: translateY(-1px); box-shadow: 0 8px 24px rgba(124,92,191,0.3); }",
        ".q28-social { text-align: center; font-size: 13px; color: #8B7EA8; margin-bottom: 8px; }",
        ".q28-social strong { color: #2D1F4E; }",
        ".q28-trust { display: flex; justify-content: center; gap: 16px; flex-wrap: wrap; }",
        ".q28-trust span { font-size: 11px; color: #8B7EA8; }",
        ".q28-qhead { font-size: 21px; font-weight: 700; color: #2D1F4E; line-height: 1.3; margin-bottom: 18px; }",
        ".q28-step { font-size: 11px; font-weight: 700; color: #8B7EA8; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 10px; }",
        ".q28-opts { display: flex; flex-direction: column; gap: 10px; }",
        ".q28-opt { display: flex; align-items: center; gap: 14px; padding: 16px 18px; background: #fff; border: 1.5px solid #DDD6EE; border-radius: 14px; cursor: pointer; transition: all 0.15s; -webkit-tap-highlight-color: transparent; user-select: none; }",
        ".q28-opt:hover { border-color: #9B7FD4; background: #F4F1F9; }",
        ".q28-opt.selected { border-color: #7C5CBF; background: #F7F5FD; }",
        ".q28-opt-text { font-size: 15px; font-weight: 500; color: #2D1F4E; line-height: 1.35; flex: 1; }",
        ".q28-opt-radio { width: 22px; height: 22px; border-radius: 6px; border: 2px solid #CCC; background: #fff; flex-shrink: 0; margin-left: auto; display: flex; align-items: center; justify-content: center; transition: all 0.2s; }",
        ".q28-opt.selected .q28-opt-radio { background: #2D1F4E; border-color: #2D1F4E; }",
        ".q28-opt.selected .q28-opt-radio::after { content: ''; width: 5px; height: 10px; border: 2.5px solid #fff; border-top: none; border-left: none; transform: rotate(45deg) translateY(-1px); display: block; }",
        ".q28-img-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 6px; }",
        ".q28-img-opt { position: relative; border-radius: 14px; overflow: hidden; border: 2.5px solid #DDD6EE; cursor: pointer; aspect-ratio: 1/1; background: #E8E0F5; transition: all 0.18s; -webkit-tap-highlight-color: transparent; }",
        ".q28-img-opt:hover { border-color: #9B7FD4; transform: scale(1.02); }",
        ".q28-img-opt.selected { border-color: #2D1F4E; box-shadow: 0 0 0 3px rgba(45,31,78,0.2); }",
        ".q28-img-opt img { width: 100%; height: 100%; object-fit: cover; display: block; }",
        ".q28-img-label { position: absolute; bottom: 0; left: 0; right: 0; background: linear-gradient(to top, rgba(45,31,78,0.88), transparent); padding: 22px 12px 12px; color: #fff; }",
        ".q28-img-label strong { display: block; font-size: 16px; font-weight: 600; }",
        ".q28-img-label span { font-size: 12px; opacity: 0.8; }",
        ".q28-popup-overlay { position: fixed; inset: 0; background: rgba(45,31,78,0.55); z-index: 999999; display: flex; align-items: center; justify-content: center; padding: 20px; }",
        ".q28-popup { background: #fff; border-radius: 24px; padding: 32px 24px 36px; width: 100%; max-width: 480px; }",
        ".q28-popup-tag { text-align: center; font-size: 11px; font-weight: 700; color: #8B7EA8; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 14px; }",
        ".q28-popup-q { font-size: 17px; font-weight: 700; color: #2D1F4E; line-height: 1.4; margin-bottom: 20px; text-align: center; }",
        ".q28-loading { text-align: center; padding: 60px 0 30px; }",
        ".q28-spinner { width: 52px; height: 52px; border: 3px solid #DDD6EE; border-top-color: #7C5CBF; border-radius: 50%; animation: q28spin 0.85s linear infinite; margin: 0 auto 20px; }",
        "@keyframes q28spin { to { transform: rotate(360deg); } }",
        ".q28-load-h { font-size: 18px; font-weight: 700; color: #2D1F4E; margin-bottom: 6px; }",
        ".q28-load-s { font-size: 13px; color: #8B7EA8; margin-bottom: 24px; }",
        ".q28-load-bar { height: 8px; background: #DDD6EE; border-radius: 4px; overflow: hidden; width: 100%; }",
        ".q28-load-fill { height: 8px; background: #7C5CBF !important; border-radius: 4px; width: 0%; transition: width 0.6s ease; display: block; }",
        "@media (max-width: 400px) { .q28-h1 { font-size: 22px; } .q28-qhead { font-size: 18px; } }"
      ].join('\n');
      document.head.appendChild(st);
    }

    var state = { path: '', zone: '' };

    var POPUP_Q = {
      belly:     'If a simple 15-minute routine designed to reduce stubborn belly fat could fit into your day, would you give it a try?',
      arms:      'If a simple 15-minute routine designed to tone and slim your arms could fit into your day, would you give it a try?',
      thighs:    'If a simple 15-minute routine designed to slim and tone your thighs could fit into your day, would you give it a try?',
      butt:      'If a simple 15-minute routine designed to lift and tone your butt could fit into your day, would you give it a try?',
      longevity: 'If a simple 15-minute Pilates routine designed to improve your health and longevity could fit into your day, would you give it a try?'
    };

    var Q3 = {
      belly:     { q: 'What would a flatter belly mean for you?',             a: ['👑 Feeling more confident in my skin', '💃 Being able to wear what I want', '📷 Looking better in photos'] },
      arms:      { q: 'What would slimmer arms mean for you?',                a: ['💃 Being able to wear what I want', '📷 Looking better in photos', '👑 Feeling more confident in my skin'] },
      thighs:    { q: 'What would slimmer thighs mean for you?',              a: ['👖 Fitting comfortably into my favorite jeans', '📷 Looking better in photos', '👑 Feeling more confident in my skin'] },
      butt:      { q: 'What would a more toned butt mean for you?',           a: ['💃 Feeling more confident in my clothes', '📷 Looking better in photos', '💪 Feeling stronger and more toned'] },
      longevity: { q: 'What would improving your health mean for your life?', a: ['⚡ Having more energy every day', '💪 Staying active as I get older', '👪 Being able to keep up with the kids', '🩷 Living a longer healthier life'] }
    };

    var IMGS = {
      belly:  'https://cdn.shopify.com/s/files/1/0583/7350/5108/files/hf_20260223_042345_2b14996c-d469-4276-90c1-8e4ef149e5c4.webp?v=1771821201',
      arms:   'https://cdn.shopify.com/s/files/1/0583/7350/5108/files/hf_20260223_042241_1c3680e1-856f-48e0-8cd8-751cd1a9947c.webp?v=1771821201',
      thighs: 'https://cdn.shopify.com/s/files/1/0583/7350/5108/files/hf_20260223_041846_9e9902fc-1f64-45e6-840c-bcd5214d8090.webp?v=1771821201',
      butt:   'https://cdn.shopify.com/s/files/1/0583/7350/5108/files/hf_20260223_042724_c3c71586-0b86-4851-8d83-d669119aa31f.webp?v=1771821201'
    };

    function prog(pct) {
      var fill = root.querySelector('.q28-progress-fill');
      if (fill) fill.style.width = pct + '%';
    }

    function show(id) {
      root.querySelectorAll('.q28-screen').forEach(function(s) { s.classList.remove('active'); });
      var el = root.querySelector('#q28s-' + id);
      if (el) el.classList.add('active');
      root.scrollTo ? root.scrollTo({ top: 0, behavior: 'smooth' }) : (root.scrollTop = 0);
    }

    function sel(el, cb) {
      var opts = el.closest('.q28-opts');
      if (opts) opts.querySelectorAll('.q28-opt').forEach(function(o) { o.classList.remove('selected'); });
      el.classList.add('selected');
      setTimeout(cb, 300);
    }

    function buildQ3(zone) {
      var data = Q3[zone];
      root.querySelector('#q28-q3-headline').textContent = data.q;
      var optsEl = root.querySelector('#q28-q3-opts');
      optsEl.innerHTML = '';
      data.a.forEach(function(answer) {
        var d = document.createElement('div');
        d.className = 'q28-opt';
        d.innerHTML = '<span class="q28-opt-text">' + answer + '</span><div class="q28-opt-radio"></div>';
        d.addEventListener('click', function() {
          sel(d, function() { show('q4'); prog(75); });
        });
        optsEl.appendChild(d);
      });
    }

    function showPopup(zone, onAnswer) {
      var overlay = document.createElement('div');
      overlay.className = 'q28-popup-overlay';
      overlay.innerHTML =
        '<div class="q28-popup">' +
          '<div class="q28-popup-tag">Almost done\u2026</div>' +
          '<p class="q28-popup-q">' + POPUP_Q[zone] + '</p>' +
          '<div class="q28-opts">' +
            '<div class="q28-opt pa"><span class="q28-opt-text">Yes \u2014 absolutely</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt pa"><span class="q28-opt-text">Yes \u2014 if it\'s easy to follow</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt pa"><span class="q28-opt-text">Maybe</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt pa"><span class="q28-opt-text">Not sure</span><div class="q28-opt-radio"></div></div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      overlay.querySelectorAll('.pa').forEach(function(el) {
        el.addEventListener('click', function() {
          el.classList.add('selected');
          setTimeout(function() {
            document.body.removeChild(overlay);
            onAnswer();
          }, 300);
        });
      });
    }

    function startLoading() {
      show('loading');
      prog(100);
      var fill = root.querySelector('.q28-load-fill');
      var loadH = root.querySelector('#q28-load-h');

      if (fill) {
        fill.style.setProperty('background', '#7C5CBF', 'important');
        fill.style.setProperty('height', '8px', 'important');
        fill.style.setProperty('display', 'block', 'important');
        fill.style.setProperty('transition', 'none', 'important');
        fill.style.width = '0%';
        fill.getBoundingClientRect();
      }

      var steps = [
        { pct: 15,  duration: 600,  text: 'Analyzing your answers\u2026' },
        { pct: 35,  duration: 900,  text: 'Matching the best routine for your goal\u2026' },
        { pct: 60,  duration: 1100, text: 'Adjusting for your available time\u2026' },
        { pct: 82,  duration: 1400, text: 'Building your personalized plan\u2026' },
        { pct: 100, duration: 1200, text: 'Unlocking your $160 transformation bundle\u2026' }
      ];

      var i = 0;
      function runStep() {
        if (i >= steps.length) {
          if (loadH) loadH.textContent = 'Your plan is ready! \u2728';
          setTimeout(function() {
            window.location.href = 'https://28pilates.com/products/total-transformation-bundle-90-day-challenge';
          }, 1200);
          return;
        }
        var s = steps[i];
        if (loadH) loadH.textContent = s.text;
        fill.style.setProperty('transition', 'width ' + s.duration + 'ms ease', 'important');
        fill.style.width = s.pct + '%';
        i++;
        setTimeout(runStep, s.duration + 200);
      }

      setTimeout(runStep, 300);
    }

    root.innerHTML =
      '<div class="q28">' +
        '<div class="q28-header">' +
          '<img src="https://cdn.shopify.com/s/files/1/0583/7350/5108/files/28_logo_75.png?v=1771867005" alt="28Pilates" style="height:34px;display:block;margin:0 auto;object-fit:contain;">' +
        '</div>' +
        '<div class="q28-progress" style="width:100% !important;height:6px !important;background:#DDD6EE !important;position:sticky !important;top:0 !important;z-index:99999 !important;display:block !important;"><div class="q28-progress-fill" style="height:6px !important;background:#7C5CBF !important;width:0%;transition:width 0.5s ease;display:block !important;"></div></div>' +
        '<div class="q28-wrap">' +

        '<div class="q28-screen active" id="q28s-intro">' +
          '<div class="q28-badge">&#128293; Limited Time &mdash; $160 Off</div>' +
          '<h1 class="q28-h1">Which <em>Pilates Routine</em> Is Best For Your Body?</h1>' +
          '<p class="q28-sub">Take this 60-second quiz and <strong>unlock $160 off</strong> your transformation bundle.</p>' +
          '<div class="q28-hero"><img src="https://cdn.shopify.com/s/files/1/0583/7350/5108/files/17_000_2.webp?v=1773103368" alt="28Pilates" loading="eager"></div>' +
          '<button class="q28-start-btn" id="q28-start">Take The Quiz &mdash; Claim $160 Off &rarr;</button>' +
          '<p class="q28-social">&#127942; <strong>170,000+ Transformations</strong></p>' +
          '<div class="q28-trust"><span>&#10004; Takes less than 60 seconds</span><span>&#10004; No email required</span></div>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-q1">' +
          '<div class="q28-step">Question 1 of 4</div>' +
          '<h2 class="q28-qhead">Which of these feels most true right now?</h2>' +
          '<div class="q28-opts">' +
            '<div class="q28-opt" id="q1a"><span class="q28-opt-text">&#128170; I\'ve gained weight and want to lose it</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q1b"><span class="q28-opt-text">&#128293; I want to tone specific areas</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q1c"><span class="q28-opt-text">&#127774; I want to stay strong and healthy as I age</span><div class="q28-opt-radio"></div></div>' +
          '</div>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-q2a">' +
          '<div class="q28-step">Question 2 of 4</div>' +
          '<h2 class="q28-qhead">Which area bothers you the most right now?</h2>' +
          '<div class="q28-img-grid">' +
            '<div class="q28-img-opt" id="img-belly"><img src="' + IMGS.belly + '" alt="Belly"><div class="q28-img-label"><strong>Belly</strong><span>Flatten &amp; strengthen</span></div></div>' +
            '<div class="q28-img-opt" id="img-arms"><img src="' + IMGS.arms + '" alt="Arms"><div class="q28-img-label"><strong>Arms</strong><span>Tone &amp; tighten</span></div></div>' +
            '<div class="q28-img-opt" id="img-thighs"><img src="' + IMGS.thighs + '" alt="Thighs"><div class="q28-img-label"><strong>Thighs</strong><span>Slim &amp; sculpt</span></div></div>' +
            '<div class="q28-img-opt" id="img-butt"><img src="' + IMGS.butt + '" alt="Butt"><div class="q28-img-label"><strong>Butt</strong><span>Lift &amp; shape</span></div></div>' +
          '</div>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-q2b">' +
          '<div class="q28-step">Question 2 of 4</div>' +
          '<h2 class="q28-qhead">What part of your health matters most right now?</h2>' +
          '<div class="q28-opts">' +
            '<div class="q28-opt" id="q2b1"><span class="q28-opt-text">&#9889; Having more energy every day</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q2b2"><span class="q28-opt-text">&#128170; Staying active as I get older</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q2b3"><span class="q28-opt-text">&#128106; Being able to keep up with the kids</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q2b4"><span class="q28-opt-text">&#129505; Living a longer healthier life</span><div class="q28-opt-radio"></div></div>' +
          '</div>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-q3">' +
          '<div class="q28-step">Question 3 of 4</div>' +
          '<h2 class="q28-qhead" id="q28-q3-headline"></h2>' +
          '<div class="q28-opts" id="q28-q3-opts"></div>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-q4">' +
          '<div class="q28-step" id="q28-q4-step">Question 4 of 4</div>' +
          '<h2 class="q28-qhead">How much time can you realistically commit to exercise each day?</h2>' +
          '<div class="q28-opts">' +
            '<div class="q28-opt" id="q4a"><span class="q28-opt-text">&#9201; 10&ndash;15 minutes</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q4b"><span class="q28-opt-text">&#128336; 20&ndash;30 minutes</span><div class="q28-opt-radio"></div></div>' +
            '<div class="q28-opt" id="q4c"><span class="q28-opt-text">&#128293; 45+ minutes</span><div class="q28-opt-radio"></div></div>' +
          '</div>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-social">' +
          '<div style="text-align:center;margin-bottom:16px;">' +
            '<div style="font-size:11px;font-weight:700;color:#8B7EA8;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;">You\'re in the right place</div>' +
            '<h2 style="font-size:22px;font-weight:700;color:#2D1F4E;line-height:1.3;margin-bottom:6px;">170,000+ Women Have Already<br><em style="color:#7C5CBF;font-style:italic;">Transformed Their Bodies</em></h2>' +
            '<div style="font-size:13px;color:#8B7EA8;margin-bottom:16px;">With just 15 minutes a day at home</div>' +
          '</div>' +
          '<div style="border-radius:16px;overflow:hidden;margin-bottom:20px;">' +
            '<img src="https://cdn.shopify.com/s/files/1/0583/7350/5108/files/Copy_of_Untitled_1.png?v=1771792306" alt="170000+ Transformations" style="width:100%;height:auto;display:block;">' +
          '</div>' +
          '<button class="q28-start-btn" id="q28-social-cta">Claim My $160 Off &rarr;</button>' +
        '</div>' +

        '<div class="q28-screen" id="q28s-loading">' +
          '<div class="q28-loading">' +
            '<div class="q28-load-h" id="q28-load-h">Analyzing your answers\u2026</div>' +
            '<div class="q28-load-bar" style="margin-top:24px;"><div class="q28-load-fill"></div></div>' +
          '</div>' +
        '</div>' +

        '</div></div>';

    root.querySelector('#q28-start').addEventListener('click', function() {
      show('q1'); prog(10);
    });

    root.querySelector('#q1a').addEventListener('click', function() {
      sel(this, function() { state.path = 'aesthetic'; show('q2a'); prog(30); });
    });
    root.querySelector('#q1b').addEventListener('click', function() {
      sel(this, function() { state.path = 'aesthetic'; show('q2a'); prog(30); });
    });
    root.querySelector('#q1c').addEventListener('click', function() {
      sel(this, function() { state.path = 'longevity'; state.zone = 'longevity'; show('q2b'); prog(30); });
    });

    ['belly','arms','thighs','butt'].forEach(function(zone) {
      root.querySelector('#img-' + zone).addEventListener('click', function() {
        root.querySelectorAll('.q28-img-opt').forEach(function(o) { o.classList.remove('selected'); });
        this.classList.add('selected');
        var z = zone;
        setTimeout(function() {
          state.zone = z;
          buildQ3(z);
          show('q3'); prog(55);
        }, 300);
      });
    });

    ['q2b1','q2b2','q2b3','q2b4'].forEach(function(id) {
      root.querySelector('#' + id).addEventListener('click', function() {
        sel(this, function() {
          var stepEl = root.querySelector('#q28-q4-step');
          if (stepEl) stepEl.textContent = 'Question 3 of 3';
          show('q4'); prog(75);
        });
      });
    });

    ['q4a','q4b','q4c'].forEach(function(id) {
      root.querySelector('#' + id).addEventListener('click', function() {
        var el = this;
        state.time = el.querySelector('.q28-opt-text').textContent;
        sel(el, function() {
          show('social'); prog(92);
        });
      });
    });

    root.querySelector('#q28-social-cta').addEventListener('click', function() {
      startLoading();
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', q28init);
  } else {
    q28init();
  }
})();